module.exports = __webpack_public_path__ + "76fd9e3c414ba654622619ea164db5c7.svg";